module.exports = __webpack_public_path__ + "static/WEDDING E&M-530-d90f306cc7e39e854ae7487bc8488483.jpg";